import rootReducer from "../../../store";
import {
  RenderPage,
  resetFormState,
  updateRendererFormState,
} from "../../../slices/common/reducer";
import { showToast } from "../../../common/Toaster/Toaster";
import {
  setDetailsData,
  setOemById,
  setOemData,
  setOemListData,
  setBenefitListData,
  setOemBenefitsData,
} from "../../../slices/product/productSlice";
import api from "../../../Utils/interface";
import { toast } from "react-toastify";

export const createProduct = (
  entity_type,
  entity,
  organizationid,
  navigator
) => {
  // Prepare the entity object, including organizationid
  const updatedEntity = {
    ...entity,
    organizationid: organizationid,
  };

  // Create a FormData instance to append all data
  let fd = new FormData();

  // Separate file data and remove file-related keys from entity
  const fileData = {};
  const entityWithoutFiles = {}; // To hold non-file data

  Object.keys(updatedEntity).forEach((key) => {
    if (
      updatedEntity[key] instanceof File ||
      updatedEntity[key]?.type === "file"
    ) {
      fileData[key] = updatedEntity[key]; // Collect file data separately
    } else {
      entityWithoutFiles[key] = updatedEntity[key]; // Keep non-file data
    }
  });

  // Append the non-file entity data
  fd.append(
    "entity",
    JSON.stringify({ ...entityWithoutFiles, organizationid })
  );
  fd.append("entitytype", entity_type); // Ensure correct entity type

  // Append the file data separately
  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];

    if (file instanceof File) {
      fd.append(key, file, file.name); // Append the new File object
    } else if (file?.type === "file") {
      fd.append(key, file.data); // Append existing file data (e.g., base64 or other format)
    }
  });

  // Make the API request
  api
    .post(`/agsp/create`, fd, {})
    .then((res) => {
      rootReducer.dispatch(resetFormState()); // Reset form state on success
      showToast("Product created successfully", "success");
      navigator("/prod/product"); // Navigate to the product list
    })
    .catch((err) => {
      showToast(err?.response?.data?.error_message, "error");
    });
};

export let updateProduct = async (entity, entityid, navigator) => {
  // Prepare the updated entity object
  const updatedEntity = {
    ...entity,
    entityid: entityid,
    entitytype: "PPET", // Ensure the entity type is correctly set
  };

  let fd = new FormData();

  // Append non-file data first (entityid, entitytype, updatedEntity)
  fd.append("entityid", entityid);
  fd.append("entitytype", updatedEntity.entitytype);

  // Separate file data and non-file data from the entity
  const fileData = {};
  const entityWithoutFiles = {}; // Non-file data

  Object.keys(updatedEntity).forEach((key) => {
    if (
      updatedEntity[key] instanceof File ||
      updatedEntity[key]?.type === "file"
    ) {
      fileData[key] = updatedEntity[key]; // Collect file data
    } else {
      entityWithoutFiles[key] = updatedEntity[key]; // Collect non-file data
    }
  });

  // Append the non-file data to FormData
  fd.append("entity", JSON.stringify({ ...entityWithoutFiles, entityid }));

  // Append the file data separately
  Object.keys(fileData).forEach((key) => {
    const file = fileData[key];

    if (file instanceof File) {
      fd.append(key, file, file.name); // Append the new File object
    } else if (file?.type === "file") {
      fd.append(key, file.data); // Append existing file data (e.g., base64 or other format)
    }
  });

  // Make the API request to update the product
  api
    .post(`/agsp/update`, fd, {})
    .then((res) => {
      rootReducer.dispatch(resetFormState()); // Reset form state on success
      showToast("Product updated successfully", "success");
      navigator("/prod/product"); // Navigate to the product list
    })
    .catch((err) => {
      console.log(err);
      showToast(err?.response?.data?.error_message, "error");
    });
};

export const getProductData = (entity_id, entity_type) => {
  let fd = new FormData();

  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);
  api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setDetailsData(res.data));
      rootReducer.dispatch(updateRendererFormState(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getDropdownDataForOem = (productId, organizationId) => {
  let fd = new FormData();

  fd.append("productId", productId);
  fd.append("organizationId", organizationId);
  api
    .post(`/product/getDropdownDataForOem`, fd)
    .then((res) => {
      rootReducer.dispatch(setOemData(res.data));
      // rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getOemData = (entity_id, entity_type) => {
  let fd = new FormData();
  fd.append("entityid", entity_id);
  fd.append("entitytype", entity_type);

  return api
    .post(`/entity/read`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setOemById(res.data));
      return res.data; // Return the response data
    })
    .catch((err) => {
      console.log(err);
      throw err; // Rethrow the error to handle it in the caller
    });
};
export let getAllAccessibleOemForProduct = (
  productId,
  entityType,
  callback
) => {
  let fd = new FormData();
  fd.append("productId", productId);
  fd.append("entityType", entityType);

  api
    .post(`/product/getAllAccessibleDataForProduct`, fd)
    .then((res) => {
      callback(res.data);
      rootReducer.dispatch(RenderPage());
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getProductToOemData = (oemId, productId) => {
  return new Promise((resolve, reject) => {
    let fd = new FormData();
    fd.append("oemId", oemId);
    fd.append("productId", productId);

    api
      .post(`/product/productToOemMapping`, fd)
      .then((res) => {
        // Optionally dispatch Redux action to update state
        // rootReducer.dispatch(setOemListData(res.data));
        resolve(res.data); // Resolve with response data if needed
      })
      .catch((err) => {
        reject(err); // Reject promise with error
        showToast(err?.response?.data?.error_message, "error");
      });
  });
};

export const addBenefitData = async (benefit, product_id) => {
  // let fd = new FormData();
  // fd.append("entityType", "PBEF");
  // fd.append("productId", product_id);

  await api
    .post(`/product/createProductBenefit`, benefit, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data) {
        getAllBenefitsList(product_id);
      }
      return res.data;
    });
};

export const deleteBenefitsList = (entityId, product_id) => {
  let fd = new FormData();
  fd.append("entityId", entityId);

  api.post(`/product/deleteProductBenefit`, fd).then((res) => {
    getAllBenefitsList(product_id);
  });
};

export const deleteProductToOemMapping = (oemId, productId) => {
  let fd = new FormData();

  fd.append("oemId", oemId);
  fd.append("productId", productId);

  return api
    .post(`/product/deleteProductToOemMapping`, fd)
    .then((res) => {
      return res.data.entityid;
    })
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getAllBenefitsList = (product_id) => {
  let fd = new FormData();
  fd.append("productId", product_id);
  fd.append("entityType", "PBEF");

  return api.post(`/product/getAllAccessibleDataForProduct`, fd).then((res) => {
    const response = res.data;
    if (response?.length === 0) {
      const addType = [
        {
          entityid: -1,
          name: "",
          type: "",
        },
      ];
      return addType;
    } else {
      // response.push({ id: Date.now(), name: "", type: "" });
      return response;
    }
  });
};

export const oemToBenefitMappping = (productId, organizationId) => {
  let fd = new FormData();

  fd.append("productId", productId);
  fd.append("organizationId", organizationId);

  api
    .post(`/product/oemToBenefitMapView`, fd, {})
    .then((res) => {
      rootReducer.dispatch(setOemBenefitsData(res.data));
    })
    .catch((err) => {
      console.log(err);
    });
};

export const productBenefitToOemMapping = (payload) => {
  api
    .post(`/product/productBenefitToOemMapping`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      console.log(res.data);
      // rootReducer.dispatch(setOemBenefitsData(res.data));
      showToast("Added successfully", "success");
    })
    .catch((err) => {
      console.log(err);
      showToast("Error while adding", "error");
    });
};

export const getBenefitList = async (productId, payload) => {
  try {
    const response = await api.post(
      `/product/updateProductBenefit?productId=${productId}`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    if (response && response.status == 200) {
      rootReducer.dispatch(setBenefitListData(response.data));
      showToast("Benefit List updated successfully", "success");
      return response.data;
    }
  } catch (error) {
    console.error("Error in getting Benefit list", error);
  }
};
